import {
	GetSystemHistoryUpdateUnitListResponse,
	TGetSystemUnitListResponse,
} from '@/services';

import { formatDate, map } from 'utils';

export const formatSystemUnitDetail = (
	input: TGetSystemUnitListResponse['content'][number]
) => {
	return {
		...input,
		registDt: formatDate(input.registDt) || '',
		updateDt: formatDate(input.updateDt) || '',
	};
};

export const formatSystemUnitList = (
	input: TGetSystemUnitListResponse['content']
) => {
	return map(input, formatSystemUnitDetail);
};

export const formatHistoryUpdateUnitDetail = (
	input: GetSystemHistoryUpdateUnitListResponse['content'][number]
) => {
	return {
		...input,
	};
};

export const formatHistoryUpdateUnitList = (
	input: GetSystemHistoryUpdateUnitListResponse['content']
) => {
	return map(input, formatHistoryUpdateUnitDetail);
};
